<template>
    <div class="te-cart-opt-in">
        <ul v-if="hasOptions" class="te-cart-opt-in__list">
            <li v-for="option in optInOptions" :key="option.id" class="te-cart-opt-in__option">
                <input type="checkbox" :id="option.id" :value="option.id" v-model="optInOn" @change="onChange">
                <label :for="option.id" class="te-cart-opt-in__option__label">{{option.question}}</label>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";

    export default {
        name: "OptIn",

        data() {
            return {
                optInOn: [],
            };
        },

        props: {
            value: {
                type: Array,
            },
            orderId: {
                type: String,
            },
            customerId: {
                type: String
            },
            preferredLanguageCode: {
                type: String
            },
            language: {
                type: Object
            },
        },

        computed: {
            ...mapGetters({
                optInOptions: 'optInOptions',
            }),

            hasOptions: function () {
                return this.optInOptions && this.optInOptions.length > 0;
            },
        },

        methods: {
            ...mapActions([
                "getOptInOptions",
            ]),

            loadOptInOptions() {
                this.getOptInOptions({orderId: this.orderId, customerId: this.customerId, preferredLanguage: this.preferredLanguageCode});
            },

            setOptInOn(optInOn) {
                this.optInOn = optInOn || [];
            },

            onChange() {
                this.$emit('input', this.optInOn);
                this.$emit('change', this.optInOn);
            },
        },

        watch: {
            value: async function(optInOn) {
                this.setOptInOn(optInOn);
            },
            orderId: async function() {
                this.loadOptInOptions();
            },
            customerId: async function() {
                this.loadOptInOptions();
            },
            preferredLanguageCode: async function() {
                this.loadOptInOptions();
            },
        },

        async created() {
            this.setOptInOn(this.value);
            if(this.orderId) {
                this.loadOptInOptions();
            }
        }

    }
</script>

<style scoped>

</style>
